// Mock data para o site Manubot CRM

export const mockData = {
  company: {
    name: 'Manubot',
    tagline: 'Orquestrador CRM',
    description: 'Gestão de canais e atendimentos criando funil de conversão para Marketing, Vendas e Cobrança',
    email: 'paulo@infomota.com.br',
    whatsapp: '5511981877765',
    website: 'manubot.com.br'
  },
  
  hero: {
    title: 'Transforme cada interação em oportunidade de negócio',
    subtitle: 'Orquestrador CRM que gerencia canais e atendimentos, criando funil de conversão para Marketing, Vendas e Cobrança',
    ctaText: 'Conhecer a Plataforma',
    secondaryCtaText: 'Falar com Especialista'
  },
  
  features: [
    {
      id: 1,
      title: 'Jornadas Dinâmicas',
      description: 'Crie jornadas personalizadas com regras baseadas em tempo, status de integração ou resposta do cliente',
      icon: 'Workflow'
    },
    {
      id: 2,
      title: 'Multicanal',
      description: 'WhatsApp, SMS, Email, Voz e RCS integrados em uma única plataforma intuitiva',
      icon: 'MessageSquare'
    },
    {
      id: 3,
      title: 'Automação Precisa',
      description: 'Disparo automatizado de mensagens multicanal com precisão cirúrgica',
      icon: 'Zap'
    },
    {
      id: 4,
      title: 'Multifornecedores',
      description: 'Escolha um ou mais fornecedores por canal e avalie desempenho de entrega e conversão',
      icon: 'Network'
    },
    {
      id: 5,
      title: 'Gestão Visual',
      description: 'Interface Kanban para gerenciar contatos por status de forma intuitiva',
      icon: 'LayoutDashboard'
    },
    {
      id: 6,
      title: 'Dashboards Customizados',
      description: 'Dashboards personalizados com indicadores de performance por canal e fornecedor',
      icon: 'BarChart3'
    }
  ],
  
  productFeatures: {
    orchestration: {
      title: 'Orquestração Multicanal Eficiente',
      description: 'Desenhe jornadas intuitivas com drag-and-drop e gerencie toda a comunicação em uma interface única',
      benefits: [
        'Design visual de jornadas com arrastar e soltar',
        'Regras dinâmicas baseadas em comportamento',
        'Segmentação avançada de contatos',
        'Histórico completo de interações'
      ]
    },
    channels: {
      title: 'Maximize o Alcance',
      description: 'Envio ativo de mensagens por múltiplos canais conectados via fornecedores, tudo gerenciado em uma interface fácil de usar',
      channels: [
        { name: 'WhatsApp', provider: 'Meta via BSP oficial' },
        { name: 'RCS', provider: 'Google RCS' },
        { name: 'SMS', provider: 'múltiplos fornecedores' },
        { name: 'Email', provider: 'integração total' },
        { name: 'Voz', provider: 'Ura e PABX' },
        { name: 'Agentes Virtuais', provider: 'Agentes Digitais de voz' }
      ]
    },
    automation: {
      title: 'Automação que Escala',
      description: 'Transforme seu relacionamento com clientes através de automação inteligente',
      stats: [
        { label: 'Taxa de Conversão Média', value: '16.8%' },
        { label: 'Canais Integrados', value: '6+' },
        { label: 'Controle Total', value: '100%' }
      ]
    }
  },
  
  about: {
    mission: 'Fazer a gestão de canais e atendimentos criando um funil de conversão para qualquer segmento: Marketing, Vendas e Cobrança. Transformamos cada interação em uma oportunidade de negócio através de tecnologia de ponta em automação e gestão de relacionamento.',
    vision: 'Ser a plataforma líder em orquestração de jornadas multicanal, permitindo que empresas escalem seus resultados de forma inteligente e sustentável através de gestão eficiente de canais e fornecedores.',
    values: [
      'Inovação constante',
      'Foco no cliente',
      'Autonomia e flexibilidade',
      'Resultados mensuráveis'
    ]
  },
  
  contactReasons: [
    'Conhecer a plataforma',
    'Solicitar demonstração',
    'Dúvidas sobre funcionalidades',
    'Integração com sistemas',
    'Suporte técnico',
    'Outros'
  ]
};